export interface IUpdateAllNotificationsActiveStatusRequest {
    isActive: boolean;
}

export class UpdateAllNotificationsActiveStatusRequest implements IUpdateAllNotificationsActiveStatusRequest {
    /**
     *
     */
    constructor(active: boolean) {
        this.isActive = active;
    }
    public isActive = false;
}